import PageManipulationOverlayButton from './PageManipulationOverlayButtonContainer';

export default PageManipulationOverlayButton;